module.exports = __webpack_public_path__ + "static/media/9.e23cf1f3.jpg";